import { ConsoleRequest, DataProviderType } from '../../../../utils/request';
import { DEFAULT_DATA_LIMIT, GetItemsRequest, GetItemsResponse } from '../../types';
import { GzSingleSelectComplexBaseDataProvider } from '../GzSingleSelectComplexBaseDataProvider';

export class UserFilterForGzRiskManagementDataProvider extends GzSingleSelectComplexBaseDataProvider {
  async getItems({ searchValue, page, limit, extra }: GetItemsRequest): Promise<GetItemsResponse | undefined> {
    try {
      const response = await ConsoleRequest.createRequest<any>({
        dataProviderType: DataProviderType.ENDPOINTS,
        endpoint: 'RiskManagementUsers',
        method: 'getDropdownUsernames',
        payload: {
          page,
          limit,
          companyId: extra?.companyId,
          username: searchValue,
          userIds: extra?.userIds,
        },
      });

      return {
        items: response.data,
        totalItemsCount: response.count,
      };
    } catch (e) {
      throw new Error(e);
    }
  }

  async getInitialItems(request: GetItemsRequest): Promise<GetItemsResponse | undefined> {
    try {
      const response = await ConsoleRequest.createRequest<any>({
        dataProviderType: DataProviderType.ENDPOINTS,
        endpoint: 'RiskManagementUsers',
        method: 'getDropdownUsernames',
        payload: {
          limit: DEFAULT_DATA_LIMIT,
          companyId: request.extra?.companyId,
          userIds: request.extra?.userIds,
        },
      });

      return {
        items: response.data,
        totalItemsCount: response.count,
      };
    } catch (e) {
      throw new Error(e);
    }
  }
}
